<template>
  <div id="app">
    <header-element />
    <router-view />
    <footer-element />
  </div>
</template>

<script>
import Header from "./elements/Header.vue";
import Footer from "./elements/Footer.vue";
import helper from "./helper.js"

export default {
  components: {
    "header-element": Header,
    "footer-element": Footer
  },
  name: "App",
  created() {
    this.$store.dispatch("fetchCapitalTypes");
    this.$store.dispatch("fetchProviderTypes");
    this.$store.dispatch("fetchCountries");
    this.$store.dispatch("fetchSectors");
    this.$store.dispatch("fetchCompanies");
    this.$store.commit("toggleBaseDataState");
    this.$store.dispatch("fetchproviderList");
    this.$store.dispatch("getChartData");
  }
};

helper.polyfillPerformanceForIE()

</script>

<style>

@import "/assets/css/style.css";

/* #app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue